import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../shared/TailwindComponents/Button';
import ColumnFields from './ColumnFields';
import { ColumnDataType } from '../../types/batchTables';

interface AddTableColumnContentProps {
  onConfirm: (data: { name: string; query?: string; data_type: ColumnDataType }) => void;
  onCancel: () => void;
}

const AddTableColumnContent: React.FC<AddTableColumnContentProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [query, setQuery] = useState('');
  const [dataType, setDataType] = useState<ColumnDataType>('text');

  const handleSubmit = useCallback(() => {
    if (!name.trim()) return;
    onConfirm({
      name: name.trim(),
      query: query.trim() || undefined,
      data_type: dataType,
    });
  }, [name, query, dataType, onConfirm]);

  return (
    <div className="w-[480px]">
      <div className="px-6 py-5 space-y-4">
        <ColumnFields
          idPrefix="add-table-column"
          name={name}
          onNameChange={setName}
          query={query}
          onQueryChange={setQuery}
          dataType={dataType}
          onDataTypeChange={setDataType}
          autoFocus
        />
      </div>

      {/* Footer */}
      <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 dark:border-gray-700">
        <Button variant="neutral" size="small" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button
          variant="primary"
          size="small"
          onClick={handleSubmit}
          disabled={!name.trim()}
        >
          {t('Add Column')}
        </Button>
      </div>
    </div>
  );
};

export default AddTableColumnContent;
